import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

const CreateOrganizationDialog = ({ open, onClose, onCreate }) => {
  const [orgName, setOrgName] = useState("");

  const handleCreate = () => {
    if (orgName.trim()) {
      onCreate(orgName.trim());
      setOrgName("");
    }
  };

  const handleClose = () => {
    setOrgName("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Create Organization</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Organization Name"
          type="text"
          fullWidth
          value={orgName}
          onChange={(e) => setOrgName(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button variant="contained" onClick={handleCreate} disabled={!orgName.trim()}>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateOrganizationDialog;
